import { Component, OnDestroy, OnInit } from '@angular/core';
import { SiparislerPage } from '../model/siparisler-page';
import { HelperProvider } from '../providers/helper.provider';
import { RestService } from '../providers/rest.service';
import { Page } from '../model/page';
import { Subscription } from 'rxjs';
import { Siparis } from 'src/model/siparis';
import { AuthService } from 'src/auth/auth.service';

@Component({
  selector: 'app-siparisler',
  templateUrl: './siparisler.component.html',
  styleUrls: ['./siparisler.component.css']
})
export class SiparislerComponent implements OnInit, OnDestroy {
  showSearchResultCountTalep = 10;
  showSearchResultCountSiparis = 10;
  showSearchResultCountSiparis2 = 10;
  showSearchResultCountModelTalep: number[] = [10, 20, 50, 100];
  showSearchResultCountModelSiparis: number[] = [10, 20, 50, 100];
  showSearchResultCountModelSiparis2: number[] = [10, 20, 50, 100];
  talepAraLoading = false;
  talepAraText = '';
  siparisAraLoading = false;
  siparisAraText = '';
  siparisAraLoading2 = false;
  siparisAraText2 = '';
  sourceSiparis: SiparislerPage = null;
  sourceSiparis2: SiparislerPage = null;
  showSearchCurrentPageTalep = 1;
  showSearchCurrentPageSiparis = 1;
  showSearchCurrentPageSiparis2 = 1;
  // durumText = 'Teklif Verilmiş Talepler';
  // sourceTalep: TaleplerPage = null;
  private subscriptions: Subscription[] = [];
  
  isOnayimdakiler: boolean = false;

  constructor(private helperProvider: HelperProvider,
    private restService: RestService,
    private authService: AuthService) {
  }

  ngOnInit(): void {
    this.helperProvider.currentPage$.next(Page.Siparisler);
    this.isOnayimdakiler = this.authService.getIsConfirm();

    this.subscriptions.push(this.helperProvider.isConfirmation$.subscribe(res => {
      if (res != null) {
        this.isOnayimdakiler = this.authService.getIsConfirm();
        this.getOnayBekleyenSiparisler();
      }
    }));
    
    // this.getBekleyenTalepler();
    this.getOnayBekleyenSiparisler();
    this.getSiparisler();
    this.subscriptions.push(this.helperProvider.changedSelectedBranches$.subscribe(res => {
      if (res != null) {
        // this.getBekleyenTalepler();
        this.getOnayBekleyenSiparisler();
        this.getSiparisler();
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  // getBekleyenTalepler() {
  //   const durum: number[] = [Talep.DURUM_TEKLIF_TOPLA];
  //   this.restService.siparisBekleyenTalepler(this.showSearchCurrentPageTalep, this.showSearchResultCountTalep, this.talepAraText).subscribe(res => {
  //     this.sourceTalep = res;
  //     this.sourceTalep.isSiparis = true;
  //   });
  // }

  getOnayBekleyenSiparisler() {
    const durum: number[] = [Siparis.DURUM_ONAY_BEKLIYOR];
    this.restService.siparisler(this.showSearchCurrentPageSiparis2, this.showSearchResultCountSiparis2, durum, this.siparisAraText2, this.isOnayimdakiler).subscribe(res => {
      this.sourceSiparis2 = res;
    });
  }

  getSiparisler() {
    const durum: number[] = [Siparis.DURUM_ONAYLANDI, Siparis.DURUM_IRSALIYE_OLUSTURULDU];
    this.restService.siparisler(this.showSearchCurrentPageSiparis, this.showSearchResultCountSiparis, durum, this.siparisAraText).subscribe(res => {
      this.sourceSiparis = res;
      this.sourceSiparis.isSiparis = true;
    });
  }

  // showPreviousPageSearchResultsTalep() {
  //   this.showSearchCurrentPageTalep--;
  //   this.getBekleyenTalepler();
  // }

  // showNextPageSearchResultsTalep() {
  //   this.showSearchCurrentPageTalep++;
  //   this.getBekleyenTalepler();
  // }

  // talepAraInputChange() {
  //   this.showSearchCurrentPageTalep = 1;
  //   this.getBekleyenTalepler();
  // }

  // new() {
  //   this.router.navigate(['talep'], {queryParams: {id: '0'}});
  // }

  showPreviousPageSearchResultsSiparis() {
    this.showSearchCurrentPageSiparis--;
    this.getSiparisler();
  }

  showNextPageSearchResultsSiparis() {
    this.showSearchCurrentPageSiparis++;
    this.getSiparisler();
  }

  siparisAraInputChange() {
    this.showSearchCurrentPageSiparis = 1;
    this.getSiparisler();
  }

  showPreviousPageSearchResultsSiparis2() {
    this.showSearchCurrentPageSiparis2--;
    this.getOnayBekleyenSiparisler();
  }

  showNextPageSearchResultsSiparis2() {
    this.showSearchCurrentPageSiparis2++;
    this.getOnayBekleyenSiparisler();
  }

  siparisAraInputChange2() {
    this.showSearchCurrentPageSiparis2 = 1;
    this.getOnayBekleyenSiparisler();
  }

  // onayGuncelle(event: any) {
  //   if (event.id && event.durum) {
  //     this.restService.siparisOnay(event.id, event.durum).subscribe(res => {
  //       this.getSiparisler();
  //     });
  //   }
  // }
}

